import { render, staticRenderFns } from "./ChangePortalAccessToken.vue?vue&type=template&id=c6f98e40&"
import script from "./ChangePortalAccessToken.vue?vue&type=script&lang=js&"
export * from "./ChangePortalAccessToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports